<label class="slider-option" [attr.for]="question?.id || 'slider'">
  <h2>{{ currentOption }}</h2>
  <div class="slider-diamond-row" *ngIf="question?.dataType === dataType.ordinal">
    <ng-container *ngIf="currentOption !== initialCallToAction">
      <div class="slider-diamond" *ngFor="let option of question?.display?.options | slice : 0 : optionIndex + 1"></div>
    </ng-container>
  </div>
</label>
<!-- NOTE: Need change event for IE and ARIA-->
<div class="slider-container">
  <input
    [attr.id]="question?.id || 'slider'"
    class="slider"
    type="range"
    #slider
    [min]="valueMin"
    [max]="valueMax"
    [step]="step"
    [value]="initialValue"
    (change)="getSliderValue(slider.value)"
    (click)="getSliderValue(slider.value)"
    [attr.aria-valuemin]="valueMin"
    [attr.aria-valuemax]="valueMax"
    [attr.aria-valuetext]="currentOption" />
  <hr class="glow" />
  <div class="diamond-ticks">
    <div class="ticks" *ngFor="let option of options"></div>
  </div>
</div>
<div class="slider-labels">
  <div class="slider-min">{{ labelMin }}</div>
  <div class="slider-max">{{ labelMax }}</div>
</div>
